import React from 'react';
import { branch, renderComponent, withProps } from 'recompose';
import { compose, not, prop } from 'ramda';
import { Redirect } from 'react-router-dom';

import connect from 'app/libs/connect';
import StackedLayout from 'app/components/layout/StackedLayout';
import Meta from 'app/features/landing/meta/components/Meta';
import HelpCenter from 'app/features/helpCenter/components/HelpCenter';
import HeroBlock from 'app/features/couponCampaign/landing/components/HeroBlock';
import { redirectUrl } from 'app/features/couponCampaign/landing/selectors';
import { parsedCoupon } from 'app/features/couponCampaign/selectors';
import { INVALID_COUPON_PATH } from 'app/router/constants/paths';
import ExternalRedirect from 'app/router/ExternalRedirect';
import withLocale from 'app/features/localization/enhancers/withLocale';

const UI = () => (
  <StackedLayout>
    <Meta />
    <StackedLayout.ContentBlock>
      <HeroBlock />
    </StackedLayout.ContentBlock>
    <StackedLayout.ContentBlock>
      <HelpCenter />
    </StackedLayout.ContentBlock>
  </StackedLayout>
);

UI.displayName = 'CouponCampaign Landing';

export { UI };

export default compose(
  connect({ to: redirectUrl, parsedCoupon }),
  branch(prop('to'), renderComponent(Redirect)),
  branch(
    compose(not, prop('parsedCoupon')),
    renderComponent(
      compose(
        withLocale,
        withProps({ to: INVALID_COUPON_PATH }),
      )(ExternalRedirect),
    ),
  ),
)(UI);
